import { useAuthState } from "react-firebase-hooks/auth";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import SignIn from "./components/SignIn";
import SignOut from "./components/SignOut";
import Home from "./content/Home";
import Colosseum from "./content/Colosseum";
import { auth } from "./firebase";
import Articles from "./content/Articles";
import Article1 from "./article/Article1";
import Article2 from "./article/Article2";
import React, { useEffect, useState } from "react";
import Colosseum1 from "./colosseum/Colosseum1";
import Article3 from "./article/Article3";
import Colosseum0 from "./colosseum/Colosseum0";
import Article4 from "./article/Article4";
import Article5 from "./article/Article5";
import Article6 from "./article/Article6";
import Article7 from "./article/Article7";
import Article8 from "./article/Article8";
import Battle from "./content/Battle";
import Article9 from "./article/Article9";
import Manual from "./content/Manual";
import Back from "./Back";
function App() {


  return (
    <div id="Body" className={localStorage.getItem("theme")}>
      {/* <BrowserRouter>
        <Routes>
          <Route path="/" element={header}>
            <Route path="/" element={<Home />} />
            <Route path="/colosseum/" element={<Colosseum />} />
            <Route path="/colosseum/0" element={<Colosseum0 />} />
            <Route path="/colosseum/1" element={<Colosseum1 />} />
            <Route path="/colosseum/2" element={<Colosseum1 />} />
            <Route path="/colosseum/3" element={<Colosseum1 />} />
            <Route path="/colosseum/4" element={<Colosseum1 />} />
            <Route path="/colosseum/5" element={<Colosseum1 />} />
            <Route path="/colosseum/6" element={<Colosseum1 />} />
            <Route path="/colosseum/7" element={<Colosseum1 />} />
            <Route path="/colosseum/8" element={<Colosseum1 />} />
            <Route path="/colosseum/9" element={<Colosseum1 />} />
            <Route path="/colosseum/10" element={<Colosseum1 />} />
            <Route path="/colosseum/11" element={<Colosseum1 />} />
            <Route path="/colosseum/12" element={<Colosseum1 />} />
            <Route path="/colosseum/13" element={<Colosseum1 />} />
            <Route path="/colosseum/14" element={<Colosseum1 />} />
            <Route path="/colosseum/15" element={<Colosseum1 />} />
            <Route path="/colosseum/16" element={<Colosseum1 />} />
            <Route path="/colosseum/17" element={<Colosseum1 />} />
            <Route path="/colosseum/18" element={<Colosseum1 />} />
            <Route path="/colosseum/19" element={<Colosseum1 />} />
            <Route path="/colosseum/20" element={<Colosseum1 />} />
            <Route path="/colosseum/21" element={<Colosseum1 />} />
            <Route path="/colosseum/22" element={<Colosseum1 />} />
            <Route path="/colosseum/23" element={<Colosseum1 />} />
            <Route path="/colosseum/24" element={<Colosseum1 />} />
            <Route path="/colosseum/25" element={<Colosseum1 />} />
            <Route path="/colosseum/26" element={<Colosseum1 />} />
            <Route path="/colosseum/27" element={<Colosseum1 />} />
            <Route path="/colosseum/28" element={<Colosseum1 />} />
            <Route path="/colosseum/29" element={<Colosseum1 />} />
            <Route path="/colosseum/30" element={<Colosseum1 />} />
            <Route path="/colosseum/31" element={<Colosseum1 />} />
            <Route path="/colosseum/32" element={<Colosseum1 />} />
            <Route path="/colosseum/33" element={<Colosseum1 />} />
            <Route path="/colosseum/34" element={<Colosseum1 />} />
            <Route path="/colosseum/35" element={<Colosseum1 />} />
            <Route path="/colosseum/36" element={<Colosseum1 />} />
            <Route path="/colosseum/37" element={<Colosseum1 />} />
            <Route path="/colosseum/38" element={<Colosseum1 />} />
            <Route path="/colosseum/39" element={<Colosseum1 />} />
            <Route path="/colosseum/40" element={<Colosseum1 />} />
            <Route path="/manual" element={<Manual />} />
            <Route path="/article/" element={<Articles />} />
            <Route path="/article/1/" element={<Article1 />} />
            <Route path="/article/2/" element={<Article2 />} />
            <Route path="/article/3/" element={<Article3 />} />
            <Route path="/article/4/" element={<Article4 />} />
            <Route path="/article/5/" element={<Article5 />} />
            <Route path="/article/6/" element={<Article6 />} />
            <Route path="/article/7/" element={<Article7 />} />
            <Route path="/article/8/" element={<Article8 />} />
            <Route path="/article/9/" element={<Article9 />} />
            <Route path="/battle/" element={<Battle />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter> */}
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<Back />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
